import { CpmInfo } from '@/common/models/cpm/CpmInfo.model';

function formatCpmInfo(eds: CpmInfo, isDemandOrganization = false): CpmInfo {
  let cpmInfo;

  if (isDemandOrganization) {
    cpmInfo = {
      ...eds,
      average: eds.buyer_average_cpm,
      min: eds.buyer_min_cpm,
      max: eds.buyer_max_cpm,
      histogram: eds.buyer_cpm_histogram,
    };
  } else {
    cpmInfo = {
      ...eds,
      average: eds.average_cpm,
      min: eds.min_cpm,
      max: eds.max_cpm,
      histogram: eds.cpm_histogram,
    };
  }

  if (cpmInfo.average == null) {
    cpmInfo.average = (cpmInfo.max - cpmInfo.min) / 2 + cpmInfo.min;
  }

  if (cpmInfo.histogram != null) {
    cpmInfo.histogramMaxCount = Math.max(...cpmInfo.histogram.map((x) => x.count));
  }

  return cpmInfo;
}

const CpmUtils = {
  formatCpmInfo,
};

export default CpmUtils;
